import {
    SECRETARIES_FAILURE,
    SECRETARIES_REQUEST,
    SECRETARIES_SUCCESS,
    SECRETARY_POST_SUCCESS,
    SECRETARY_DELETE_SUCCESS,
    SECRETARY_PATCH_SUCCESS,
} from 'actions';
import preserveArrayReference from 'utils/Array/preserveArrayReference';

const initialState = {
    data: [],
    isFetched: false,
    isFetching: false,
};

export default (state = initialState, action) => {
    const { type, data, secretary } = action;
    switch (type) {
        case SECRETARY_DELETE_SUCCESS: {
            const newData = state.data.filter(d => d.id !== secretary)
            return {
                ...state,
                data: [...newData]
            }
        }

        case SECRETARY_PATCH_SUCCESS: {
            return {
                ...state,
                data: state.data.map(d => d.id === secretary.id ? secretary : d)
            }
        }

        case SECRETARY_POST_SUCCESS: {
            return {
                ...state,
                data: [...state.data, secretary]
            }
        }

        case SECRETARIES_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            data: preserveArrayReference(state.data, data),
        }}

        case SECRETARIES_REQUEST: {return {
            ...state,
            isFetching: true,
        }}

        case SECRETARIES_FAILURE: {return {
            ...state,
            isFetching: false,
        }}

        default: {return state}
    }
};
